import { render, staticRenderFns } from "./CustomerSearchResult.vue?vue&type=template&id=31b6ad0f&scoped=true"
import script from "./CustomerSearchResult.vue?vue&type=script&lang=js"
export * from "./CustomerSearchResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b6ad0f",
  null
  
)

export default component.exports